export default function AboutAIBlock() {
  return (
    <section className="py-24 bg-stone-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
          <div>
            <span className="text-amber-600 text-xs font-bold uppercase tracking-widest mb-3 block">About Us</span>
            <h2 className="font-serif text-4xl md:text-5xl font-bold text-stone-900 mb-6 leading-tight">
              What Does Book My Studio Space Do?
            </h2>
            <p className="text-stone-600 text-base md:text-lg leading-relaxed mb-8">
              Book My Studio Space provides accessible, professional studio environments for creators and businesses who need high-quality spaces without long-term commitments. We operate a network of fully equipped studio locations across major US cities with easy online booking.
            </p>

            <div className="mb-8">
              <p className="text-stone-900 font-bold text-xs uppercase tracking-widest mb-4 flex items-center gap-2">
                <i className="ri-building-4-line text-amber-500" />
                What We Provide
              </p>
              <ul className="space-y-2">
                {[
                  'Photography studios with lighting, backdrops, and prep areas',
                  'Video production rooms with cinema support and acoustic treatment',
                  'Podcast recording booths with broadcast microphones and mixing',
                  'Content creation studios with streaming gear and colorful backdrops',
                  'Large-format event and creative venue spaces',
                ].map((item) => (
                  <li key={item} className="flex items-start gap-3">
                    <i className="ri-arrow-right-s-line text-amber-500 text-base mt-0.5 flex-shrink-0" />
                    <span className="text-stone-600 text-sm leading-relaxed">{item}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <p className="text-stone-900 font-bold text-xs uppercase tracking-widest mb-4 flex items-center gap-2">
                <i className="ri-checkbox-circle-line text-amber-500" />
                Why Creators Choose Us
              </p>
              <ul className="space-y-2">
                {[
                  'No long-term lease or studio ownership required',
                  'Professional-grade equipment at every location',
                  'Instant online booking with same-day availability',
                  'Clean, reset spaces maintained to studio-grade standards',
                  'Dedicated support team for every booking',
                ].map((b) => (
                  <li key={b} className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-amber-500 text-base mt-0.5 flex-shrink-0" />
                    <span className="text-stone-600 text-sm leading-relaxed">{b}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="space-y-6">
            {/* Who it's for */}
            <div className="bg-white rounded-2xl p-7 border border-stone-200">
              <p className="text-stone-900 font-bold text-xs uppercase tracking-widest mb-5 flex items-center gap-2">
                <i className="ri-user-line text-amber-500" />
                Who This Service Is For
              </p>
              <div className="grid grid-cols-1 gap-2">
                {[
                  'Photographers and visual artists',
                  'Videographers and filmmakers',
                  'Podcasters and audio journalists',
                  'Social media influencers and content creators',
                  'Marketing agencies and brand teams',
                  'Event producers and workshop facilitators',
                ].map((item) => (
                  <div key={item} className="flex items-center gap-3 py-2 border-b border-stone-100 last:border-0">
                    <div className="w-7 h-7 flex items-center justify-center bg-amber-100 rounded-full flex-shrink-0">
                      <i className="ri-check-line text-amber-600 text-xs" />
                    </div>
                    <span className="text-stone-700 text-sm">{item}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Values */}
            <div className="bg-stone-900 rounded-2xl p-7 text-white">
              <p className="text-amber-400 font-bold text-xs uppercase tracking-widest mb-5">Our Core Values</p>
              <div className="space-y-4">
                {[
                  { icon: 'ri-star-line', title: 'Professional Excellence', desc: 'Every studio is maintained to professional broadcast and production standards.' },
                  { icon: 'ri-time-line', title: 'Radical Flexibility', desc: 'No minimums, no commitments. Book what you need, when you need it.' },
                  { icon: 'ri-heart-line', title: 'Creator First', desc: 'Every decision is made with the needs of the working creator in mind.' },
                ].map((val) => (
                  <div key={val.title} className="flex items-start gap-4">
                    <div className="w-9 h-9 flex items-center justify-center bg-amber-500/20 rounded-lg flex-shrink-0">
                      <i className={`${val.icon} text-amber-400 text-base`} />
                    </div>
                    <div>
                      <p className="text-white font-semibold text-sm mb-1">{val.title}</p>
                      <p className="text-stone-400 text-xs leading-relaxed">{val.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
